<div class="modal-close" (click)="closeModal()">
  <fa-icon class="icon me-1" [icon]="faTimes"></fa-icon
  ><span>{{ "btn:close" | translate }}</span>
</div>
<div class="modal-header justify-content-start">
  <h4 class="modal-title">
    {{ "Confirm" | translate }}
  </h4>
</div>
<div class="modal-body flex-column mx-2">
  <div class="row">
    <p class="description">
      {{
        "dashboard:admin:modal:desactivate:users"
          | translate: { number: numbAccounts }
      }}
    </p>
  </div>
  <div class="users">
    <div class="row mt-2" *ngFor="let user of users">
      <div class="col-1">
        <td class="align-middle">
          <app-user-icon size="medium" [user]="user"></app-user-icon>
        </td>
      </div>
      <div class="col ms-3">
        <p class="mb-0">{{ user.name }}</p>
        <p class="mb-0" style="color: #969696">{{ user.email }}</p>
      </div>
    </div>
  </div>
</div>
<div class="row justify-content-end modal-footer">
  <hr class="common-separator my-0" />
  <div class="row justify-content-end text-center">
    <div class="col-2">
      <button
        type="button"
        class="btn btn-outline-primary ms-2 fs-15 text-nowrap"
        (click)="closeModal()"
      >
        {{ "Cancel" | translate }}
      </button>
    </div>
    <div class="col-4">
      <button
        (click)="desactivateMembers()"
        type="button"
        role="tab"
        class="btn btn-primary text-nowrap"
        [disabled]="loadSpin"
      >
        <fa-icon
          class="mr-2"
          [icon]="faCircleNorch"
          *ngIf="loadSpin"
          [spin]="true"
        ></fa-icon>
        {{ "Yes, desactivate" | translate }}
      </button>
    </div>
  </div>
</div>
